import React from "react";
import { Box, LinearProgressProps } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

import { styled } from "@mui/system";

const BorderLinearProgress = styled(LinearProgress)<{
  bgColor?: string;
}>(({ theme, bgColor }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: bgColor || "#F2EEE8",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#06A3B0",
  },
}));

interface CustomLinearProgressBarProps extends LinearProgressProps {
  value: number;
  backgroundColor?: string;
}

const CustomLinearProgressBar: React.FC<CustomLinearProgressBarProps> = ({
  value,
  backgroundColor,
}) => {
  return (
    <Box display="flex" alignItems="center">
      <Box width="120px" mr={1}>
        <BorderLinearProgress variant="determinate" value={value} bgColor={backgroundColor} />
      </Box>
    </Box>
  );
};

export default CustomLinearProgressBar;
